<template>
  <div>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-1'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-1'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-2'
        )
      }}</strong>
      <br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-2-1'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-2-1'
          )
        "
      />
      <br /><br />
      <span style="padding-left: 100px" v-html="renderFormula(formula1)" />
      <br /><br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-2-1b'
          )
        "
      />
      <br /><br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-2-2'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-2-2'
          )
        "
      />
      <br /><br />
      <span style="padding-left: 100px" v-html="renderFormula(formula2)" />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-3'
        )
      }}</strong>
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.info-3'
          )
        "
      />
    </b-notification>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.title-4'
        )
      }}</strong>
      <br />
      <ul style="list-style-type: square; margin-left: 25px">
        <li>
          <span
            v-html="
              $t(
                'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.ref-4-1'
              )
            "
          />
        </li>
        <li>
          <span
            v-html="
              $t(
                'compCarbonFormsRactivitiesComponentsAstroHelpCalculatingMethod.ref-4-2'
              )
            "
          />
        </li>
      </ul>
    </b-notification>
  </div>
</template>

<script>
import katex from 'katex'

export default {
  name: 'HelpCalculatingMethod',
  data () {
    return {
      formula1:
        'EC_{\\rm infra} = {GES_{\\rm construction} \\over {\\rm amortissement}} + GES_{\\rm opérations}',
      formula2:
        'EC_{\\rm labo} = \\sum_i \\left( EC_{\\rm infra_i} \\times \\%\\text{utilisation}_{\\rm infra_i}^{\\rm labo} \\right)'
    }
  },
  methods: {
    renderFormula: function (formula) {
      return katex.renderToString(formula, {
        throwOnError: false,
        output: 'mathml'
      })
    }
  }
}
</script>
